<template>
  <span class="text-button typo-sm-medium" @click="$emit('click')">{{ label }}</span>
</template>

<script>
export default {
  name: 'TextButton',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.text-button {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/TextButton.vue